import * as React from "react";

import type { DesignaliProps } from "../../types";

export const MonitorOff = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2" />
        <path d="M22 15V5a2 2 0 0 0-2-2H9" />
        <path d="M8 21h8" />
        <path d="M12 17v4" />
        <path d="m2 2 20 20" />
      </svg>
    );
  },
);

export default MonitorOff;
